export default __webpack_public_path__ + "static/logo-d0525e13016532e3e7e29d210ad80b36.jpg";